import {Component, OnInit} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {NgxPermissionsService} from 'ngx-permissions';
import {NgxPermissionsObject} from 'ngx-permissions/lib/service/permissions.service';

const adminMenus = [
  {label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/dashboard']},
  {
    label: 'Booking',
    icon: 'pi pi-fw pi-shopping-cart',
    expanded: false,
    items: [
      {label: 'Golf Booking', icon: 'pi pi-fw pi-search', routerLink: ['/reserves']},
      {label: 'Leisure Booking', icon: 'pi pi-fw pi-ticket', routerLink: ['/leisure']},
      {
        label: 'Transfer',
        icon: 'pi pi-fw pi-send',
        items: [
          {label: 'Daily', icon: 'pi pi-fw pi-clock', url: 'https://admin-transfer.golfdigg.com/login' , target: '_blank'},
          // {label: 'Monthly', icon: 'pi pi-fw pi-calendar', routerLink: ['/reserves/transfer-summary']},
          // {label: 'Transactions', icon: 'pi pi-fw pi-table', routerLink: ['/transfers']},
        ]
      },
    ]
  },

  {
    label: 'Time Slot', icon: 'pi pi-fw pi-calendar-plus',
    expanded: false,
    items: [
      // {label: 'Dashboard', icon: 'pi pi-fw pi-chart-pie', routerLink: ['/slots/dashboard']},
      {label: 'Manage', icon: 'pi pi-fw pi-calendar-plus', routerLink: ['/slots/manage']},
      {label: 'Overview', icon: 'pi pi-fw pi-table', routerLink: ['/slots/monitor']},
      // {label: 'Test', icon: 'pi pi-fw pi-plus', routerLink: ['/slots/test']},
    ]
  },
  {
    label: 'User', icon: 'pi pi-fw pi-users', routerLink: ['/user'], expanded: false,
  },
  {
    label: 'Price Rule', icon: 'pi pi-fw pi-calendar-plus',
    expanded: false,
    items: [
      {label: 'Price Rule', icon: 'pi pi-fw pi-table', routerLink: ['/price-rule']},
      {label: 'Summary', icon: 'pi pi-fw pi-table', routerLink: ['/price-rule/summary']},
    ]
  },
  {
    label: 'Course', icon: 'pi pi-fw pi-folder',
    expanded: false,
    items: [
      {label: 'Course', icon: 'pi pi-fw pi-building-columns', routerLink: ['/course']},
      {
        label: 'Remark', icon: 'pi pi-fw pi-comments', items: [
          {label: 'Active Remark', icon: 'pi pi-fw pi-comments', routerLink: ['/course/remark']},
          {label: 'Manage Remark', icon: 'pi pi-fw pi-wrench', routerLink: ['/course/remark-manage']},
        ]
      },
      {
        label: 'Calendar/Event',
        icon: 'pi pi-fw pi-calendar-times',
        routerLink: ['/configuration/calendar-setting']
      },
      {label: 'Holiday', icon: 'pi pi-fw pi-calendar-clock', routerLink: ['/configuration/holiday']},
      {
        label: 'Other', icon: 'pi pi-fw pi-tag', items: [
          {label: 'Area', icon: 'pi pi-fw pi-map-marker', routerLink: ['/course/areas']},
          {label: 'Icon', icon: 'pi pi-fw pi-sun', routerLink: ['/course/icons']}
        ]
      },
    ]
  },
  {
    label: 'Portal', icon: 'pi pi-fw pi-folder',
    expanded: false,
    items: [
      {label: 'Login', icon: 'pi pi-fw pi-users', routerLink: ['/portal/partner-login']},
    ]
  },
  {
    label: 'Leisure', icon: 'pi pi-fw pi-folder',
    expanded: false,
    items: [
      {label: 'Shop', icon: 'pi pi-fw pi-building-columns', routerLink: ['/shop']},
      {label: 'Supplier', icon: 'pi pi-fw pi-building-columns', routerLink: ['/supplier']},
      {label: 'Package', icon: 'pi pi-fw pi-building-columns', routerLink: ['/package']},
      {label: 'Package Item', icon: 'pi pi-fw pi-building-columns', routerLink: ['/package-item']},
      {label: 'Package Category', icon: 'pi pi-fw pi-pencil', routerLink: ['/package/package-category']},
    ]
  },
  {
    label: 'Top Golf',
    icon: 'pi pi-fw pi-shopping-cart',
    expanded: false,
    items: [
      {label: 'Orders', icon: 'pi pi-fw pi-search', routerLink: ['/top-golf/order']},
      {label: 'Bay Manage', icon: 'pi pi-fw pi-calendar', routerLink: ['/top-golf/bay']},
    ]
  },
  // {
  //     label: 'Voucher', icon: 'pi pi-fw pi-percentage', routerLink: ['/vouchers']
  // },
  {
    label: 'Voucher', icon: 'pi pi-fw pi-percentage', items: [
      {label: 'Voucher', icon: 'pi pi-fw pi-tags', routerLink: ['/voucher/list']},
      {label: 'Template', icon: 'pi pi-fw pi-tags', routerLink: ['/voucher/template']},
    ]
  },
  {
    label: 'Reward', icon: 'pi pi-fw pi-gift', routerLink: ['/rewards']
  },
  {
    label: 'App Config', icon: 'pi pi-fw pi-desktop',
    items: [
      {label: 'AppHome', icon: 'pi pi-fw pi-home', routerLink: ['/app-config/home-config-list']},
      {label: 'Inbox', icon: 'pi pi-fw pi-inbox', routerLink: ['/inbox/inbox-list']},
      {
        label: 'Promotion Banner',
        icon: 'pi pi-fw pi-flag',
        routerLink: ['/staff-email/promotion-banner']
      },
    ]
  },
  {
    label: 'Transfer',
    icon: 'pi pi-fw pi-send',
    badgeClass: 'text-green-500',
    items: [
      // {label: 'Daily', icon: 'pi pi-fw pi-clock', routerLink: ['/reserves/transfer']},
      {label: 'Daily(New)', icon: 'pi pi-fw pi-table', routerLink: ['/transfers/daily']},
      {label: 'Refund Pending', icon: 'pi pi-fw pi-undo', routerLink: ['/transfers/refund-pending']},
      {label: 'Transactions', icon: 'pi pi-fw pi-table', routerLink: ['/transfers']},
      {label: 'Coupon', icon: 'pi pi-fw pi-tag', routerLink: ['/coupon']},
      {label: 'Course Credit', icon: 'pi pi-fw pi-credit-card', routerLink: ['/reserves/golf-course-credit']},
      {label: 'Monthly', icon: 'pi pi-fw pi-calendar', routerLink: ['/reserves/transfer-summary']},
    ]
  },

  {
    label: 'Monitor', icon: 'pi pi-fw pi-chart-line',
    items: [
      {label: 'Revenue', icon: 'pi pi-fw pi-chart-line', routerLink: ['/monitor/revenue']},
      {label: 'Product', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/monitor/product']},
    ]
  },

  {
    label: 'Summary Report',
    icon: 'pi pi-fw pi-cloud-download',
    expanded: false,
    items: [
      {
        label: 'Revenue Report', icon: 'pi pi-fw pi-table', routerLink: ['/report/revenue']
      },
      {
        label: 'Transfer Report', icon: 'pi pi-fw pi-wallet', routerLink: ['/report/transfer']
      },
      {label: 'New Customer', icon: 'pi pi-fw pi-user-plus', routerLink: ['/report/new-customer']},
      {label: 'Active User', icon: 'pi pi-fw pi-users', routerLink: ['/report/user-reserve']},
    ]
  },
];

const accountingMenu = {
  label: 'Accounting Report',
  icon: 'pi pi-fw pi-file-excel',
  routerLink: ['/report/sale-report']
};

const settingMenu = {
  label: 'Settings',
  icon: 'pi pi-fw pi-cog',
  expanded: false,
  items: [
    {label: 'General', icon: 'pi pi-fw pi-home', routerLink: ['/settings/general']},
    {label: 'Bank Account', icon: 'pi pi-fw pi-book', routerLink: ['/settings/bank-account']},
  ]
};

const toolMenu = {
  label: 'Utilities Tool',
  icon: 'pi pi-fw pi-hammer',
  expanded: false,
  items: [
    {label: 'Listmonk Formatter', icon: 'pi pi-fw pi-envelope', routerLink: ['/utilities/listmonk']},
    {label: 'Kbank Exporter', icon: 'pi pi-fw pi-envelope', routerLink: ['/utilities/kbank-export']},
  ]
};

const golfBag = {
  label: 'Golf Bag',
  icon: 'pi pi-fw pi-shopping-bag',
  expanded: false,
  items: [
    {label: 'Tracking', icon: 'pi pi-fw pi-box', routerLink: ['/golf-bag/tracking-booking']},
    {label: 'Location Setting', icon: 'pi pi-fw pi-map-marker', routerLink: ['/golf-bag/location-setting']},
    {label: 'Time Setting', icon: 'pi pi-fw pi-clock', routerLink: ['/golf-bag/time-setting']},
    {label: 'Price Configuration', icon: 'pi pi-fw pi-dollar', routerLink: ['/golf-bag/price-config']},
  ]
};

@Component({
  selector: 'app-menu',
  template: `
    <div class="menu">
      <ul class="layout-menu">
        <!--                <li>-->
        <!--                    <span class="p-input-icon-left w-12">-->
        <!--                        <i class="pi pi-search"></i>-->
        <!--                        <input type="text" pInputText placeholder="Search" class="p-inputtext-sm border-round"/>-->
        <!--                    </span>-->
        <!--                </li>-->
        <li app-menuitem
            *ngFor="let item of model; let i = index;"
            [item]="item"
            [index]="i"
            [root]="true"></li>
      </ul>
    </div>
  `
})
export class AppMenuComponent implements OnInit {

  model: MenuItem[];

  constructor(private permissionsService: NgxPermissionsService) {
    this.permissionsService.permissions$.subscribe((p: NgxPermissionsObject) => {
      if (p.ADMIN) {
        this.model = [...adminMenus, accountingMenu, toolMenu, settingMenu, golfBag];
      } else if (p.ACCOUNTANT) {
        this.model = [accountingMenu];
      }
    });
  }

  ngOnInit() {

  }
}
